export default __webpack_public_path__ + "static/media/@eigabbi.e9968a53.jpg";